import { MediaKind } from 'modules/manager/domain/media-kind';

export interface ChampionshipMediaTemplateGroupGql {
  id: number;
  name: string;
  tournamentId: number | null;
  templatesCount: number;
}

export interface ChampionshipMediaKindGql {
  kind: string;
  title: string;
  templateType: string;
  subjectType: string;
  supported: boolean;
}

export interface ChampionshipMediaRuleGql {
  id: number;
  kind: string;
  enabled: boolean;
  template: { id: number; name: string } | null;
  templatePinned: boolean;
  blockedReason: string | null;
}

export interface ChampionshipMediaSettingsGql {
  championshipId: number;
  timezone: string;
  templateGroup: ChampionshipMediaTemplateGroupGql | null;
  kinds: ChampionshipMediaKindGql[];
  rules: ChampionshipMediaRuleGql[];
}

const SETTINGS_FIELDS = `
  championshipId
  timezone
  templateGroup {
    id
    name
    tournamentId
    templatesCount
  }
  kinds {
    kind
    title
    templateType
    subjectType
    supported
  }
  rules {
    id
    kind
    enabled
    template {
      id
      name
    }
    templatePinned
    blockedReason
  }
`;

export const CHAMPIONSHIP_MEDIA_SETTINGS_QUERY = `#graphql
  query championshipMediaSettings($championshipId: Int!) {
    championshipMediaSettings(championshipId: $championshipId) {
      ${SETTINGS_FIELDS}
    }
  }
`;

export const ASSIGN_CHAMPIONSHIP_TEMPLATE_GROUP_MUTATION = `#graphql
  mutation assignChampionshipTemplateGroup($championshipId: Int!, $templateGroupId: Int!) {
    assignChampionshipTemplateGroup(championshipId: $championshipId, templateGroupId: $templateGroupId) {
      ${SETTINGS_FIELDS}
    }
  }
`;

export const UNASSIGN_CHAMPIONSHIP_TEMPLATE_GROUP_MUTATION = `#graphql
  mutation unassignChampionshipTemplateGroup($championshipId: Int!) {
    unassignChampionshipTemplateGroup(championshipId: $championshipId) {
      ${SETTINGS_FIELDS}
    }
  }
`;

export const UPDATE_TOURNAMENT_TIMEZONE_MUTATION = `#graphql
  mutation updateTournamentTimezone($tournamentId: Int!, $timezone: String!) {
    updateTournamentTimezone(tournamentId: $tournamentId, timezone: $timezone) {
      id
      timezone
    }
  }
`;

export type ChampionshipMediaBlockedReason = 'no_group' | 'unsupported' | 'no_template' | 'no_plan_feature';

export interface ChampionshipMediaKindRow {
  kind: MediaKind;
  title: string;
  templateType: string;
  subjectType: string;
  supported: boolean;
  enabled: boolean;
  templateName: string | null;
  blockedReason: ChampionshipMediaBlockedReason | null;
}

export interface ChampionshipMediaSettings {
  championshipId: number;
  timezone: string;
  templateGroup: ChampionshipMediaTemplateGroupGql | null;
  kinds: ChampionshipMediaKindRow[];
}
